import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as TrialIcon } from '../../assets/svg/TrialIcon.svg';
import { ReactComponent as StarterIcon } from '../../assets/svg/StarterIcon.svg';
import { ReactComponent as AdvancedIcon } from '../../assets/svg/AdvancedIcon.svg';
import { ReactComponent as FamilyIcon } from '../../assets/svg/FamilyIcon.svg';
import { ReactComponent as Save } from '../../assets/svg/Save.svg';
import '../../styles/modals/StudentInfoModal.css';
import Loading from '../Loading';
import { setUserSubscription } from '../../server/server';
import { notify } from '../../utils/util';

const subscriptionPlanList = [
	// { name: 'free', icon: <TrialIcon />, color: '#CAE5FF' },
	{ name: 'premium', icon: <StarterIcon />, color: '#CAE5FF' },
];

const durationList = [
	{ name: 'Extend for a month', code: 'oneMonth' },
	{ name: 'Extend for a 3 months', code: 'threeMonths' },
	{ name: 'Extend for a year', code: 'endOfTheYear' },
	{ name: 'Lifetime', code: 'lifetime' },
];

function ChangeSubscriptionModal({ modalIsOpen, closeModal, user = null, reloadList }: { modalIsOpen: any; closeModal: any; user: any; reloadList?: any }) {
	const [processing, setProcessing] = useState(false);
	const [selectedPlanIndex, setSelectedPlanIndex] = useState(-1);
	const [selectedDurationIndex, setSelectedDurationIndex] = useState(-1);
	const cleanUpFunction = () => {
		setSelectedPlanIndex(-1);
		setSelectedDurationIndex(-1);
	};

	const handlePlan = (index: number) => {
		setSelectedPlanIndex(index);
	};

	const handleDuration = (index: number) => {
		setSelectedDurationIndex(index);
	};

	const handleSave = async () => {
		if (selectedPlanIndex === -1 || selectedDurationIndex === -1) return;

		setProcessing(true);
		try {
			const resp = await setUserSubscription({
				userId: user?.id,
				subscriptionPlan: subscriptionPlanList[selectedPlanIndex].name,
				duration: durationList[selectedDurationIndex].code,
			});

			if (resp.status === 200 || resp.status === 201) {
				notify('Subscription updated successfully!');
				reloadList?.();
				closeModal();
			} else {
				notify('Failed to update subscription');
			}
		} catch (error) {
			console.error(error);
			notify('Unexpected error updating subscription');
		} finally {
			setProcessing(false);
		}
	};

	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 800,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon ' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>

				<div className='bg-white rounded-xl mx-3 flex-1 flex flex-col gap-5 px-[40px] py-[25px]'>
					<div className='flex-1'>
						<p className='text-primaryViolet font-semibold text-3xl text-left'>Edit user's subscription</p>
					</div>

					<p className='text-darkenPurple text-[20px] leading-6 font-bold mt-3 '>Subscription plan</p>
					<div className='grid grid-cols-2 justify-center mx-auto gap-3 '>
						{subscriptionPlanList.map((item: any, index: number) => (
							<div className={`w-[300px] p-[15px] flex flex-col gap-3 items-center justify-center  rounded-[20px]  cursor-pointer border-[2px] ${selectedPlanIndex === index ? 'shadow-lg' : ''}`} key={index} onClick={() => handlePlan(index)} style={{ backgroundColor: item.color, borderColor: selectedPlanIndex === index ? '#5e639b' : item.color }}>
								{item.icon}
								<p className='text-darkenPurple text-[20px] leading-6 font-bold capitalize'>{item.name}</p>
							</div>
						))}
					</div>
					<p className='text-darkenPurple text-[20px] leading-6 font-bold mt-3 '>Duration</p>
					<div className='grid grid-cols-2 justify-center mx-auto gap-3 '>
						{durationList.map((item: any, index: number) => (
							<div className={`w-[300px] p-[15px] flex flex-col gap-3 items-center justify-center  rounded-[20px] bg-[#CAE5FF] cursor-pointer border-[2px] ${selectedDurationIndex === index ? 'border-primaryViolet shadow-lg' : 'border-[#CAE5FF]'}`} key={index} onClick={() => handleDuration(index)}>
								<p className='text-darkenPurple text-[20px] leading-6 font-bold'>{item.name}</p>
							</div>
						))}
					</div>
					<div className='flex flex-row justify-end w-full gap-5 mt-2'>
						{/* <div
							className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer rounded-full bg-[#fafaff]  h-[60px] button-transparent-class'
							onClick={closeModal}
						>
							<p className='text-[18px] text-primaryViolet leading-5 font-semibold mr-3 '>Back</p>
						</div> */}
						<button className='flex-1 max-w-[160px] flex flex-row items-center justify-center cursor-pointer  rounded-full bg-primaryViolet  min-h-[60px] button-save-class transition' disabled={processing || selectedPlanIndex === -1 || selectedDurationIndex === -1} onClick={handleSave}>
							{processing ? (
								<Loading primaryColor='#FDDF6D' secondaryColor='#5E639B' size={25} stroke={7} />
							) : (
								<div className='flex flex-row items-center justify-center'>
									<p className='text-[18px]  leading-5 font-semibold mr-3 '>Save</p>
									<Save />
								</div>
							)}
						</button>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default ChangeSubscriptionModal;
